import { className } from 'lib/css'
import { RefObject, createRef } from 'preact'
import { useMemo } from 'preact/hooks'
import ChatScrollContext from 'ui/components/conversation/event/chat-scroll/chat-scroll-context'
import UnreadMessagesButton from 'ui/components/conversation/event/chat-scroll/unread-messages-button'
import useChatScroll from 'ui/components/conversation/use-chat-scroll'
import { useEvents } from 'ui/hooks/seamly-hooks'

const ChatScrollProvider = ({ children }) => {
  const events = useEvents()
  const eventRefs = useMemo(
    () =>
      events.reduce<Record<string, RefObject<HTMLElement>>>((acc, value) => {
        if (!value.payload.id) return acc

        acc[value.payload.id] = createRef()
        return acc
      }, {}),
    [events],
  )

  const { scrollToRef, scrollToBottom, containerRef, unreadIds } =
    useChatScroll(eventRefs)

  return (
    <ChatScrollContext.Provider
      value={{
        eventRefs,
        unreadIds,
        scrollToRef,
        scrollToBottom,
        containerRef,
      }}
    >
      <div className={className('chat__container')}>
        <div
          className={className('chat__container__scroll-area')}
          ref={containerRef}
        >
          {children}
        </div>
        <UnreadMessagesButton />
      </div>
    </ChatScrollContext.Provider>
  )
}

export default ChatScrollProvider
